import { render, staticRenderFns } from "./XmPopover.vue?vue&type=template&id=79d5dc80"
import script from "./XmPopover.vue?vue&type=script&lang=js"
export * from "./XmPopover.vue?vue&type=script&lang=js"
import style0 from "./XmPopover.vue?vue&type=style&index=0&id=79d5dc80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports